import { requestBuilder } from '../../../http/RequestBuilder';
import { type NewBeneficiary } from '../../components/beneficiaries/Beneficiaries';

export const useCreateAndAddBeneficiary = requestBuilder.mutation<
    {
        success: boolean;
    },
    NewBeneficiary
>({
    endpoint: '/api/beneficiary/create-and-add-to-accounts',
    method: 'POST',
});

export const useAddExistingBeneficiary = requestBuilder.mutation<
    {
        success: boolean;
    },
    {
        bankAccountIds: string[];
        beneficiaryId: string;
    }
>({
    endpoint: '/api/beneficiary/add-to-accounts',
    method: 'POST',
});
